export const environment = {
    production: false,
    apiHost: 'https://api.ccbc.staging.wceruw.org'
};